export const VIN_PREFIXES = ['X0T', 'LFW', 'ECB', 'BP', 'PT', 'SPM', 'BS'] as const;
export type VinPrefix = (typeof VIN_PREFIXES)[number];

export const TAIL_MAX_LENGTH = 15;
export const VIN_MIN_FULL_LENGTH = 14;
/** Символы, запрещённые в хвосте VIN (убираем I, O, Q и всё нелатинское/нецифровое) */
export const TAIL_ALLOWED = /[^A-HJ-NPR-Z0-9]/g;

export const CYRILLIC_TO_LATIN: Record<string, string> = {
  А: 'A', В: 'B', Е: 'E', К: 'K', М: 'M',
  Н: 'H', О: 'O', Р: 'P', С: 'C', Т: 'T',
  У: 'Y', Х: 'X',
};

/** Заменяет кириллические омоглифы латинскими эквивалентами (А→A, О→O и т.д.) */
export function transliterate(input: string): string {
  return input.replace(/[А-Я]/g, (ch) => CYRILLIC_TO_LATIN[ch] ?? '');
}

/** Очищает хвост VIN: транслитерация + удаление запрещённых символов + обрезка */
export function cleanTail(raw: string): string {
  return transliterate(raw.toUpperCase())
    .replace(TAIL_ALLOWED, '')
    .slice(0, TAIL_MAX_LENGTH);
}

/** Recognises a complete VIN pasted/typed into the field intended for its tail. */
export function splitFullVin(raw: string): { prefix: VinPrefix; tail: string } | null {
  const cleaned = transliterate(raw.toUpperCase()).replace(TAIL_ALLOWED, '');
  const prefix = VIN_PREFIXES.find((item) => cleaned.startsWith(item));
  if (!prefix || cleaned.length < VIN_MIN_FULL_LENGTH || cleaned.length > prefix.length + TAIL_MAX_LENGTH) return null;
  const tail = cleaned.slice(prefix.length);
  return tail ? { prefix, tail } : null;
}

/** Prevents X0T + X0T… when a user enters a complete VIN after the prefix selector. */
export function normalizeVinParts(prefix: VinPrefix, rawTail: string): { prefix: VinPrefix; tail: string; vin: string; fullVinDetected: boolean } {
  const full = splitFullVin(rawTail);
  if (full) return { ...full, vin: full.prefix + full.tail, fullVinDetected: true };
  const tail = cleanTail(rawTail);
  return { prefix, tail, vin: prefix + tail, fullVinDetected: false };
}
